import { render, staticRenderFns } from "./bool-select.vue?vue&type=template&id=51f52ed7&"
import script from "./bool-select.vue?vue&type=script&lang=ts&"
export * from "./bool-select.vue?vue&type=script&lang=ts&"
import style0 from "./bool-select.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports